// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__FTr4B","title":"AfterFrontImage_title__bHLtz"};